import React from 'react';
import { Button } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';

const Logout: React.FC = () => {
  const { logout } = useAuth0();

  return (
    <Button variant="contained" onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}>
      Log out
    </Button>
  );
};

export default Logout;
